import { initMonitoring } from "./core/monitoring";

// Run Datadog initialization from Next's client instrumentation hook so it starts
// before component effects and route error boundaries report errors.
//
// Unconditional on purpose: RUM and Logs collect for every visitor regardless of
// the banner answer (T-3337, reaffirmed at the flip on T-3800). The consent
// decision reaches Datadog only as the `analytics_consent` facet, which the
// instrumentation stack's datadog sink stamps once the visitor decides.
initMonitoring();
